import React from 'react';
import { FDBox } from '@facet-wealth/design';
import { DataValueMap } from 'Helpers/Testing';

const ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewContent = () => {
  return (
    <FDBox {...DataValueMap.init('scenario-selection-redefined-the-year-ahead-goal-strategies-overview-step-content').build()} />
  );
};

ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewContent.defaultProps = {
};

ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewContent.propTypes = {
};

export default ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewContent;
